import axios from 'axios';
import { VerifyAuth } from './axiosInterceptor';

const API = process.env.REACT_APP_API_PATH;



export const unSubscribeEmailNotification = async (data) => {
  try {

    return await axios
      .get(`${API}/notification/subscription/email/${data}`, {
        headers: {
          'Content-Type': 'application/json'
        },
      })
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        return err.response;
      });
  } catch (err) {
    return err;
  }
};
